import React from "react";
import {paxService} from "../../jwt/_services/clasificator/paxService";

export const paxProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await paxService.getOptions( customFilter );

        return listItems.map((item) => {
            return (
                {
                    id: item?.id,
                    value: item?.code,
                    label: <label>{ item?.name }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}